<template>
  <div id="visualization">
    <div class="inner-wrapper">
      <main class="inner-content">
        <SectionHeader />
        <div class="row">
          <SectionToggles />
        </div>
        <InvTabs :tabs="tabs" :startTab="startTab">
          <template #tabpanel-mobility>
            <header>
              <div>
                <YearAndStage />
              </div>
            </header>

            <div class="content">
              <MobilityText :class="'subtitle'" />
              <div class="mobility-viz-container">
                <div class="row">
                  <div class="col-50 centered stat">
                    <EdssScale :enlargeScale="true" />
                  </div>
                  <div class="col-50">
                    <MobilityVideo :class="'relative'" />
                  </div>
                  <EdssScore :showScore="true" />
                </div>
              </div>
            </div>
          </template>
          <template #tabpanel-mri>
            <header>
              <div>
                <YearAndStage />
              </div>
            </header>

            <div class="mri-results content">
              <MriResultsBlock />
            </div>
          </template>

          <template #tabpanel-neuronal>
            <header>
              <div>
                <YearAndStage />
              </div>
            </header>

            <div class="content">
              <NeuronalHealthText :class="'subtitle'" />
              <div class="neuron-viz-container">
                <NeuronImages :class="'relative'" />
              </div>
            </div>
          </template>
        </InvTabs>
        <Findings />
      </main>
    </div>
  </div>
</template>

<script>
import MobilityVideo from "@/components/MobilityVideo.vue";
import MobilityText from "@/components/MobilityText.vue";

import MriResultsBlock from "@/components/MriResultsBlock.vue";

import NeuronalHealthText from "@/components/NeuronalHealthText.vue";
import NeuronImages from "@/components/NeuronImages.vue";

import EdssScale from "@/components/EdssScale";
import YearAndStage from "@/components/YearAndStage.vue";
import EdssScore from "@/components/EdssScore.vue";

import progressionMixin from "@/mixins/progressionMixin";

import InvTabs from "@/components/InvTabs.vue";
import SectionHeader from "@/components/SectionHeader.vue";
import SectionToggles from "@/components/SectionToggles.vue";

import Findings from "@/components/Findings.vue";

export default {
  name: "Mobility",
  mixins: [progressionMixin],
  components: {
    MobilityVideo,
    MobilityText,
    MriResultsBlock,
    NeuronalHealthText,
    NeuronImages,
    EdssScale,
    YearAndStage,
    InvTabs,
    SectionHeader,
    SectionToggles,
    Findings,
    EdssScore,
  },
  data() {
    return {
      tabs: {
        mobility: "Mobility",
        mri: "MRI Results",
        neuronal: "Neuronal Health",
      },
    };
  },
  created() {
    this.name = this.$route.params.name;
    this.startTab = this.$route.params.startTab;
    this.year = parseInt(this.$route.params.year);
    this.$store.updateYear(this.year);
  },
  methods: {
    goBack(e) {
      e.preventDefault();
      this.$router.push({ name: "disease-progression" });
    },
  },
};
</script>

<style lang="scss" scoped>
#visualization {
  header {
    display: block;
    position: relative;

    .btn.back {
      position: absolute;
      top: 0;
      right: 0;
      &:focus {
        outline: 4px solid#FFD086;
      }
    }
  }

  .inner-content {
    .content {
      padding: rem(15px) 0;
      padding-bottom: 0;
      max-width: 100%;
    }
  }

  #year-and-stage {
    font-size: rem(24px);
    font-weight: $font-weight-bold;
  }

  .subtitle {
    font-size: rem(24px);
    width: 80%;
    margin-bottom: rem(10px);
  }

  .centered {
    text-align: center;
  }

  #edss-score {
    display: inline-block;
  }

  #mobility-video {
    width: 485px;
    height: 562px;
    right: 175px;
    @include breakpoint(xs) {
      width: 275px;
      top: 150px;
      right: 70px;
    }
  }

  .edss-score {
    left: 70%;
    top: 15%;
    @media (max-width: 950px) {
      font-size: 1.5rem;
    }
    @include breakpoint(xs) {
      font-size: 1rem;
      left: 50%;
      top: 20%;
    }
    ::v-deep span {
      &.score {
        @media (max-width: 950px) {
          font-size: rem(80px);
        }
        @include breakpoint(xs) {
          font-size: rem(55px);
          margin-right: 0.3rem;
        }
      }
    }
  }

  .icon-container-viz {
    margin-top: rem(50px);
    display: inline-block;
    text-align: left;
  }

  // Mobility
  ::v-deep #mobility-video {
    overflow: hidden;

    video {
      position: relative;
      left: -15%;
    }
  }

  // .neuron-viz-container,
  // .mri-viz-container

  .mobility-viz-container {
    // border: 1px solid rgba($white, 0.35);
    position: relative;

    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      -webkit-box-shadow: inset 3px 3px 150px 9px rgba(0, 0, 0, 0.5);
      -moz-box-shadow: inset 3px 3px 150px 9px rgba(0, 0, 0, 0.5);
      box-shadow: inset 3px 3px 150px 9px rgba(0, 0, 0, 0.5);
    }

    .row {
      display: flex;
      flex-basis: auto;
    }

    .stat {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      z-index: 1;
      padding-left: rem(50px);
      @include breakpoint(xs) {
        padding-left: rem(10px);
      }
    }
  }

  .lesions-btn {
    display: none;
    @include breakpoint(xs) {
      display: block;
      border: none;
      background: transparent;
      border: 1px solid $blue-light;
      padding: 10px 15px;
      border-radius: 5px;
      margin-top: 25px;
      z-index: 10000;
    }
  }

  ::v-deep .neuron-wrapper {
    @include breakpoint(xs) {
      top: -45px;
    }
  }

  // footer having issue with page load of MRI images, fixing with fixed height for content container
  .mri-viz-container {
    height: rem(574px);
    @include breakpoint(xs) {
      height: auto;
    }
  }

  // ::v-deep #lesions-content {
  //   .mri-images {
  //     // background: $blue-dark;
  //   }
  // }
}
</style>
